import React from 'react';
import PropTypes from 'prop-types';
import { NavBarGroup, NavBarPrimary, InfoUserGroup } from './TopNavBar.style';
import NavBarItemComponent from './NavBarItemComponent';

const DistrictAdminNavBar = ({
  state,
  props,
  navBarItemProps,
  renderUserIcon,
}) => {
  const { isDropdown } = state;
  const { user } = props;

  return (
    <NavBarGroup>
      <NavBarPrimary>
        <NavBarItemComponent 
          {...navBarItemProps} 
          url="/admin/reports/generator" 
          icon="chalktalk-icon-reports" 
          dataTip="" 
          label="Reports" 
        />
      </NavBarPrimary>
      <InfoUserGroup>
        <NavBarPrimary>{renderUserIcon(user, isDropdown)}</NavBarPrimary>
      </InfoUserGroup>
    </NavBarGroup>
  );
};

DistrictAdminNavBar.propTypes = {
  state: PropTypes.shape({
    isDropdown: PropTypes.bool.isRequired
  }).isRequired,
  props: PropTypes.shape({
    user: PropTypes.object.isRequired
  }).isRequired,
  navBarItemProps: PropTypes.object.isRequired,
  renderUserIcon: PropTypes.func.isRequired
};

export default DistrictAdminNavBar; 